import Vue from 'vue';
import Vuex from 'vuex';
import { router } from '@/router';

import { registerModule, initializeRegisterModule } from './registerModule';
import getters from './getters';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import plugins from './plugins';
import { actionTypes } from '@/types';
import { nativeMethodCall } from '@/tools/nativeInterface';

// Modules
import areaBeaconAlgorithm from './modules/areaBeaconAlgorithm';
import augmentedReality from './modules/augmentedReality';
// import connection from './modules/connection';
import contentModal from './modules/contentModal';
import customMap from './modules/customMap';
import geoLocation from './modules/geoLocation';
import history from './modules/history';
import nativeBluetooth from './modules/bluetooth';
import packageSyncer from './modules/packageSyncer';
import nearestBeaconAlgorithm from './modules/nearestBeaconAlgorithm';
import playerAudio from './modules/playerAudio';
import playerVideo from './modules/playerVideo';
import scroll from './modules/scroll';
import search from './modules/search';
import swipe from './modules/swipe';
import systemInfo from './modules/systemInfo';
import tour from './modules/tour';
import tutorial from './modules/tutorial';
import dmx from './modules/dmx';
import progressiveWebApp from './modules/progressiveWebApp';
import commandHandler from './modules/commandHandler';
import editorApi from './modules/editorApi';
import modal from './modules/modal';
import phidget from './modules/phidget';

Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);

const store = new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state,
	getters,
	mutations,
	actions: Object.assign(actions, {
		// This action loads a plugin from a URL and passes the store to
		// the plugin, the plugin can register its own module namespace
		// in the store.
		// This action needs the store, to avoid circlycal dependencies
		// it is not implemented in the actions.js file.
		[actionTypes.loadPlugin]({ state }, { pluginName, url }) {
			return new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.type = 'text/javascript';
				script.onload = () => {
					if (pluginName in window) {
						window[pluginName]({
							store,
							router,
							JS2NativeInterface: { nativeMethodCall },
						});
						resolve();
					} else reject();
				};
				script.onerror = (error) => {
					reject(error);
					// TODO: Add better error
				};
				document.body.appendChild(script);
				script.src = url ? url : `${state.dataSourceURL}apps/${pluginName}/index.js`;
			});
		},
	}),
	plugins,
});

// register modules to have working plugins
initializeRegisterModule(store);
registerModule('packageSyncer', packageSyncer);
registerModule('systemInfo', systemInfo);
registerModule('history', history);
registerModule('scroll', scroll);
registerModule('swipe', swipe);
registerModule('augmentedReality', augmentedReality);
registerModule('bluetooth', nativeBluetooth);
registerModule('nearestBeaconAlgorithm', nearestBeaconAlgorithm);
registerModule('playerAudio', playerAudio);
registerModule('playerVideo', playerVideo);
registerModule('contentModal', contentModal);
registerModule('search', search);
registerModule('customMap', customMap);
registerModule('areaBeaconAlgorithm', areaBeaconAlgorithm);
registerModule('tour', tour);
registerModule('tutorial', tutorial);
registerModule('geoLocation', geoLocation);
registerModule('dmx', dmx);
registerModule('progressiveWebApp', progressiveWebApp);
registerModule('commandHandler', commandHandler);
registerModule('editorApi', editorApi);
registerModule('modal', modal);
registerModule('phidget', phidget);
// registerModule('connection', connection);

export default store;
